import Icon from '../components/Icon.vue'

Icon.register({
  'comment-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 0H64C28.7 0 0 28.7 0 64V352C0 387.3 28.7 416 64 416H160V500C160 509.8 171.2 515.5 179.1 509.7L304 416H448C483.3 416 512 387.3 512 352V64C512 28.7 483.3 0 448 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-alt.js
// module id = 2+a2
// module chunks = 144